import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'
import { convertDate, dateCheck } from '@shared-submodule/utils'

import CustomLink from '@shared/components/customLink'

export default function Header({ data }) {
  return (
    <>
      <section className={styles.matchHeader}>
        <div className={`${styles.head} d-md-flex align-items-start justify-content-between mb-3 mb-md-4`}>
          <div>
            <h1>
              {data?.sTitle}
              {data?.sSubtitle && ', ' + data?.sSubtitle} - {'Live Cricket Score'}
            </h1>
            <p className="text-muted mb-0">
              <span>
                <CustomLink href={`/${data?.oSeries?.oCategory?.oSeo?.sSlug || data?.oSeries?.oSeo?.sSlug}`} prefetch={false}>
                  <a className='fw-bold' >
                    {data?.oSeries?.sTitle}
                    {data?.oSeries?.sSeason && ', ' + data?.oSeries?.sSeason}
                  </a>
                </CustomLink>
              </span>
              <span>{data?.dStartDate && ' | ' + convertDate(dateCheck(data?.dStartDate))}</span>
              <span>{data?.oVenue?.sName && ' | ' + data?.oVenue?.sName}</span>
            </p>
          </div>
        </div>
      </section>
    </>
  )
}

Header.propTypes = {
  data: PropTypes.object
}
